import type { VistaCard } from "../contratos";

import estilos from "./card.module.css";
import { Bloco } from "./util";

export function Pergunta({ vista, numero }: { vista: VistaCard; numero: number }) {
  return (
    <Bloco numero={numero} titulo="Uma pergunta para você">
      <p className={estilos.destaque}>{vista.pergunta || "Comparado com o quê?"}</p>
    </Bloco>
  );
}
